import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication/authentication.service";
import {AccountSiteService} from '../account-site.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard  {

  constructor(private authenticationService: AuthenticationService, private accountSiteService: AccountSiteService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authenticationService.isUserLoggedIn()) {
      this.accountSiteService.goToLoginPage(true);
      return false;
    } else if (!this.authenticationService.doesUserHaveBuildingAccount()) {
      this.accountSiteService.goToDashboardPage();
      return false;
    } else {
      return true;
    }
  }
}
